import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslatePipe } from '@ngx-translate/core';
import { Table } from '../../../../shared/table/table';

@Component({
  selector: 'app-table-section',
  imports: [
    CommonModule,
    FormsModule,
    Table,
    TranslatePipe
  ],
  templateUrl: './table-section.html',
  styleUrl: './table-section.css',
})
export class TableSection {

  @Input() tableConfig: any;

  @Input() editable = false;

  addRow(): void {

    const row: any = {};

    this.tableConfig.columns.forEach((col: any) => {
      row[col.key] = '';
    });

    this.tableConfig.data.push(row);

  }

  deleteRow(index: number): void {

    this.tableConfig.data.splice(index, 1);

  }

}